<template>
  <div>
    <div class="organisationDetail">
      <div class="pb-3 ml-4 mt-2">
        <div class="row">
          <div class="col-4">Name of the Organization</div>
          <div class="col-sm">{{organizationDetail.nameOfTheOrganization}}</div>
        </div>

        <div class="row">
          <div class="col-4">Associate with L&T as a</div>
          <div class="col-sm">{{organizationDetail.associateWithLnt}}</div>
        </div>

        <div class="row">
          <div class="col-4">Country</div>
          <div class="col-sm">{{organizationDetail.country}}</div>
        </div>

        <div class="row">
          <div class="col-4">{{organizationDetail.idCardName}}</div>
          <div class="col-sm">{{organizationDetail.pan}}</div>
        </div>

        <div class="row">
          <div class="col-4">Business Type</div>
          <div class="col-sm">
            <div
              v-for="(businessType,index) in organizationDetail.businessTypes"
              :key="index"
            >{{businessType}}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">DUNS Number</div>
          <div v-if="organizationDetail.dunsNumber" class="col-sm">{{organizationDetail.dunsNumber}}</div>
          <div v-else class="col-sm">--</div>
        </div>
      </div>

      <div class="pb-3">
        <div class="inner-title col">Contact Detail</div>
        <div class="ml-4">
          <div class="row">
            <div class="col-4">Coordinate Person</div>
            <div class="col-sm">{{organizationDetail.coOrdinatePerson}}</div>
          </div>

          <div class="row">
            <div class="col-4">Designation</div>
            <div class="col-sm">{{organizationDetail.designation}}</div>
          </div>

          <div class="row">
            <div class="col-4">Mobile Number</div>
            <div class="col-sm">+{{organizationDetail.isdCode}}-{{organizationDetail.mobileNumber}}</div>
          </div>

          <div class="row">
            <div class="col-4">Email</div>
            <div class="col-sm">{{organizationDetail.email}}</div>
          </div>
        </div>
      </div>

      <div class="pb-3" v-if="!branchLogIn">
        <div class="inner-title col">Registered Office Address</div>
        <div class="ml-4">
          <div class="row">
            <div class="col-4">Street Address</div>
            <div class="col-sm">{{organizationDetail.registeredOfficeAddress.streetAddress}}</div>
          </div>
          <div class="row">
            <div class="col-4">Country</div>
            <div class="col-sm">{{organizationDetail.registeredOfficeAddress.country}}</div>
          </div>
          <div class="row">
            <div class="col-4">State</div>
            <div class="col-sm">{{organizationDetail.registeredOfficeAddress.state}}</div>
          </div>
          <div class="row">
            <div class="col-4">City</div>
            <div class="col-sm">{{organizationDetail.registeredOfficeAddress.city}}</div>
          </div>
          <div class="row">
            <div class="col-4">Zipcode</div>
            <div class="col-sm">{{organizationDetail.registeredOfficeAddress.zipcode}}</div>
          </div>
        </div>
      </div>

      <div class="pb-3">
        <div class="inner-title col">Correspondence Office Address</div>
        <div class="ml-4">
          <div class="row">
            <div class="col-4">Street Address</div>
            <div class="col-sm">{{organizationDetail.correspondenceAddress.streetAddress}}</div>
          </div>
          <div class="row">
            <div class="col-4">Country</div>
            <div class="col-sm">{{organizationDetail.correspondenceAddress.country}}</div>
          </div>
          <div class="row">
            <div class="col-4">State</div>
            <div class="col-sm">{{organizationDetail.correspondenceAddress.state}}</div>
          </div>
          <div class="row">
            <div class="col-4">City</div>
            <div class="col-sm">{{organizationDetail.correspondenceAddress.city}}</div>
          </div>
          <div class="row">
            <div class="col-4">Zipcode</div>
            <div class="col-sm">{{organizationDetail.correspondenceAddress.zipcode}}</div>
          </div>
        </div>
      </div>

      <div class="pb-3">
        <div class="inner-title col">Statutory Information</div>
        <div class="ml-4">
          <div class="row" v-if="!branchLogIn">
            <div class="col-4">Incorporated as</div>
            <div class="col-sm">{{organizationDetail.incorporatedAs}}</div>
          </div>
          <div class="row">
            <div class="col-4">Year of Incorporation</div>
            <div class="col-sm">{{organizationDetail.yearOfIncorporation}}</div>
          </div>
          <div class="row" v-if="!branchLogIn">
            <div class="col-4">Place of Incorporation</div>
            <div class="col-sm">{{organizationDetail.placeOfIncorporation}}</div>
          </div>
          <div class="row" v-if="organizationDetail.cinNumber">
            <div class="col-4">CIN Number</div>
            <div class="col-sm">{{organizationDetail.cinNumber}}</div>
          </div>
          <div class="row" v-if="organizationDetail.llpinNumber">
            <div class="col-4">LLPIN Number</div>
            <div class="col-sm">{{organizationDetail.llpinNumber}}</div>
          </div>
          <div class="row" v-if="organizationDetail.frnNumber">
            <div class="col-4">Firm Registration Number</div>
            <div class="col-sm">{{organizationDetail.frnNumber}}</div>
          </div>
          <div class="row" v-if="organizationDetail.sernNumber">
            <div class="col-4">Shop Establishment and Reg Number</div>
            <div class="col-sm">{{organizationDetail.sernNumber}}</div>
          </div>
          <div class="row" v-if="organizationDetail.isMsme">
            <div class="col-4">Is MSME</div>
            <div class="col-sm">{{organizationDetail.isMsme == 'Y' ? 'Yes' : 'No'}}</div>
          </div>
          <div class="row" v-if="organizationDetail.msmeNumber">
            <div class="col-4">MSME Number</div>
            <div class="col-sm">{{organizationDetail.msmeNumber}}</div>
          </div>
          <div class="row" v-if="organizationDetail.msmeType">
            <div class="col-4">MSME Type</div>
            <div class="col-sm">{{organizationDetail.msmeType}}</div>
          </div>
          <div class="row" v-if="organizationDetail.sector">
            <div class="col-4">MSME Sector</div>
            <div class="col-sm">{{organizationDetail.sector}}</div>
          </div>
          <div class="row" v-if="organizationDetail.investedAmount">
            <div class="col-4">MSME investedAmount</div>
            <div class="col-sm">{{organizationDetail.investedAmount}}</div>
          </div>
          <div class="row" v-if="organizationDetail.effectiveFrom">
            <div class="col-4">MSME EffectivePeriod</div>
            <div
              class="col-sm"
            >{{organizationDetail.effectiveFrom}} to {{organizationDetail.effectiveUpto}}</div>
          </div>
          <div class="row" v-if="organizationDetail.gstNumber">
            <div class="col-4">GST Number</div>
            <div class="col-sm">{{organizationDetail.gstNumber}}</div>
          </div>
          <div class="row" v-if="organizationDetail.gstDocumentId">
            <div class="col-4">GST DocumentID</div>
            <div class="col-sm">
              <a
                @click="showFile(organizationDetail.gstDocumentId)"
                href="#"
              >{{getAttachmentName(organizationDetail.gstDocumentId)}}</a>
            </div>
          </div>

          <div class="row" v-if="organizationDetail.isEinvoiceApplicable">
            <div class="col-4">E-Invoice Applicable</div>
            <div class="col-sm">{{organizationDetail.isEinvoiceApplicable == 'Y' ? 'Yes' : 'No'}}</div>
          </div>
          <div class="row" v-if="organizationDetail.isTCSApplicable">
            <div class="col-4">ECS Applicable</div>
            <div class="col-sm">{{organizationDetail.isTCSApplicable == 'Y' ? 'Yes' : 'No'}}</div>
          </div>
          
          <div class="row" v-if="organizationDetail.tanNumber">
            <div class="col-4">TAN Number</div>
            <div class="col-sm">{{organizationDetail.tanNumber}}</div>
          </div>
          <div class="row" v-if="organizationDetail.tanDocumentId">
            <div class="col-4">TAN DocumentID</div>
            <div class="col-sm">
              <a
                @click="showFile(organizationDetail.tanDocumentId)"
                href="#"
              >{{getAttachmentName(organizationDetail.tanDocumentId)}}</a>
            </div>
          </div>

          
          <div class="row" v-if="organizationDetail.vatNumber">
            <div class="col-4">VAT Number</div>
            <div class="col-sm">{{organizationDetail.vatNumber}}</div>
          </div>
          <div class="row" v-if="organizationDetail.vatDocumentId">
            <div class="col-4">VAT Document</div>
            <div class="col-sm">
              <a
                @click="showFile(organizationDetail.vatDocumentId)"
                href="#"
              >{{getAttachmentName(organizationDetail.vatDocumentId)}}</a>
            </div>
          </div>

          
          <div class="row" v-if="organizationDetail.aadhaarNumber">
            <div class="col-4">Aadhaar Number</div>
            <div class="col-sm">{{organizationDetail.aadhaarNumber}}</div>
          </div>
          <div class="row" v-if="organizationDetail.aadhaarDocumentId">
            <div class="col-4">Aadhaar DocumentID</div>
            <div class="col-sm">
              <a
                @click="showFile(organizationDetail.aadhaarDocumentId)"
                href="#"
              >{{getAttachmentName(organizationDetail.aadhaarDocumentId)}}</a>
            </div>
          </div>

        </div>
      </div>

      <div class="pb-3" v-if="organizationDetail.country.toLowerCase() == 'india'">
        <div class="inner-title col">Registration Code Reference</div>
        <div class="ml-4">
          <div class="row" v-if="organizationDetail.pfRegistrationId">
            <div class="col-4">PF Registration Id</div>
            <div class="col-sm">{{organizationDetail.pfRegistrationId}}</div>
          </div>
          <div class="row" v-if="organizationDetail.pfRegionalOffice">
            <div class="col-4">PF Regional Office</div>
            <div class="col-sm">{{organizationDetail.pfRegionalOffice}}</div>
          </div>
          <div class="row" v-if="organizationDetail.pfEmployeeCount">
            <div class="col-4">PF Employee Count</div>
            <div class="col-sm">{{organizationDetail.pfEmployeeCount}}</div>
          </div>

          <div class="row" v-if="organizationDetail.esiRegistrationId">
            <div class="col-4">ESI Registration Id</div>
            <div class="col-sm">{{organizationDetail.esiRegistrationId}}</div>
          </div>
          <div class="row" v-if="organizationDetail.esiRegionalOffice">
            <div class="col-4">ESI Regional Office</div>
            <div class="col-sm">{{organizationDetail.esiRegionalOffice}}</div>
          </div>
          <div class="row" v-if="organizationDetail.esiRemarks">
            <div class="col-4">ESI Remarks</div>
            <div class="col-sm">{{organizationDetail.esiRemarks}}</div>
          </div>
        </div>
      </div>

      <div class="pb-3">
        <div class="inner-title col">Contact Details</div>
        <div class="table-wrapper-scroll-y my-custom-scrollbar table-responsive-lg">
          <table class="table table-striped mb-0">
            <thead>
              <tr>
                <th scope="col">Sl No</th>
                <th scope="col">Name</th>
                <th scope="col">Designation</th>
                <th scope="col">Department</th>
                <th scope="col">Mobile Number</th>
                <th scope="col">Email</th>
                <th scope="col">Category</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(contactDetail,index) in organizationDetail.contactDetails" :key="index">
                <td scope="col">{{index+1}}</td>
                <td scope="col">{{contactDetail.name}}</td>
                <td scope="col">{{contactDetail.designation}}</td>
                <td scope="col">{{contactDetail.department}}</td>
                <td scope="col">+{{organizationDetail.isdCode}}-{{contactDetail.mobileNumber}}</td>
                <td scope="col">{{contactDetail.email}}</td>
                <td scope="col">{{contactDetail.category}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="pb-3">
        <div class="inner-title col" v-if="organizationDetail.factoryDetail!= ''">Factory Details</div>
        <div
          class="table-wrapper-scroll-y my-custom-scrollbar table-responsive-lg"
          v-if="organizationDetail.factoryDetail != ''"
        >
          <table class="table table-striped mb-0">
            <thead>
              <tr>
                <th scope="col">Sl No</th>
                <th scope="col">Factory Name</th>
                <th scope="col">Street Address</th>
                <th scope="col">Country</th>
                <th scope="col">State</th>
                <th scope="col">City</th>
                <th scope="col">Zipcode</th>
                <th scope="col">Factory Inspector’s Certificate Number</th>
                <th scope="col">Shop Establishment Certificate Number</th>
                <th scope="col">Year of commencement of Manufacturing</th>
                <th scope="col">Total Area</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(factory,index) in organizationDetail.factoryDetail" :key="index">
                <td scope="col">{{index+1}}</td>
                <td scope="col">{{factory.factoryName}}</td>
                <td scope="col">{{factory.streetAddress}}</td>
                <td scope="col">{{factory.country}}</td>
                <td scope="col">{{factory.state}}</td>
                <td scope="col">{{factory.city}}</td>
                <td scope="col">{{factory.postalCode}}</td>
                <td scope="col">{{factory.inspectionCfNo}}</td>
                <td scope="col">{{factory.establishmentCfNo}}</td>
                <td scope="col">{{factory.yearCommencementMfg}}</td>
                <td scope="col">{{factory.totalArea}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="inner-title col"
        v-if="organizationDetail.factoryWarehouseDetail.length > 0"
      >Factory Attached Warehouse</div>
      <div
        class="table-wrapper-scroll-y my-custom-scrollbar table-responsive-lg"
        v-if="organizationDetail.factoryWarehouseDetail.length > 0"
      >
        <table class="table table-striped mb-0">
          <thead>
            <tr>
              <th scope="col">Sl No</th>
              <th scope="col">Factory Name</th>
              <th scope="col">Warehouse Name</th>
              <th scope="col">Street Address</th>
              <th scope="col">City</th>
              <th scope="col">State</th>
              <th scope="col">Zipcode</th>
              <th scope="col">Country</th>
              <th scope="col">Stock Value</th>
              <th scope="col">Total Area</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(factoryWarehouseDetail,index) in organizationDetail.factoryWarehouseDetail"
              :key="index"
            >
              <td scope="col">{{index+1}}</td>
              <td scope="col">{{factoryWarehouseDetail.factoryName}}</td>
              <td scope="col">{{factoryWarehouseDetail.warehouseName}}</td>
              <td scope="col">{{factoryWarehouseDetail.streetAddress}}</td>
              <td scope="col">{{factoryWarehouseDetail.city}}</td>
              <td scope="col">{{factoryWarehouseDetail.state}}</td>
              <td scope="col">{{factoryWarehouseDetail.postalCode}}</td>
              <td scope="col">{{factoryWarehouseDetail.country}}</td>
              <td scope="col">{{factoryWarehouseDetail.stockValue}}</td>
              <td scope="col">{{factoryWarehouseDetail.totalArea}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="inner-title col"
        v-if="organizationDetail.warehouseDetail.length > 0"
      >Warehouse Details</div>
      <div
        class="table-wrapper-scroll-y my-custom-scrollbar table-responsive-lg"
        v-if="organizationDetail.warehouseDetail.length > 0"
      >
        <table class="table table-striped mb-0">
          <thead>
            <tr>
              <th scope="col">Sl No</th>
              <th scope="col">Warehouse Name</th>
              <th scope="col">Street Address</th>
              <th scope="col">City</th>
              <th scope="col">State</th>
              <th scope="col">Zipcode</th>
              <th scope="col">Country</th>
              <th scope="col">Stock Value</th>
              <th scope="col">Total Area</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(warehouseDetail,index) in organizationDetail.warehouseDetail" :key="index">
              <td scope="col">{{index+1}}</td>
              <td scope="col">{{warehouseDetail.warehouseName}}</td>
              <td scope="col">{{warehouseDetail.streetAddress}}</td>
              <td scope="col">{{warehouseDetail.city}}</td>
              <td scope="col">{{warehouseDetail.state}}</td>
              <td scope="col">{{warehouseDetail.postalCode}}</td>
              <td scope="col">{{warehouseDetail.country}}</td>
              <td scope="col">{{warehouseDetail.stockValue}}</td>
              <td scope="col">{{warehouseDetail.totalArea}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <w-loadingSpinner :loadSpinner="loading" />
  </div>
</template>
<script>
import { PartnerService } from "../../services/partnerService";
import loadingSpinner from "../../widgets/LoadingSpinner";
const partnerService = new PartnerService();
export default {
  props: ["organizationDetail", "branchLogIn"],
  components: {
    "w-loadingSpinner": loadingSpinner
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    showFile(documentId) {
      this.loading = true;
      partnerService
        .downLoadDocument(documentId)
        .then(res => {
          this.loading = false;
          // alert("Downlodeded1");
        })
        .catch(e => {});
    },
    getAttachmentName(documentId) {
      let attachmentName = "";
      attachmentName = documentId.split(/_(.+)/)[1]
        ? documentId.split(/_(.+)/)[1]
        : documentId;
      return attachmentName;
    }
  }
};
</script>
<style scoped>
.inner-title {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  font-stretch: normal;
  line-height: 1.25;
  text-align: left;
  padding-bottom: 1%;
}
.organisationDetail {
  margin-bottom: 8px;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: 0.16px;
  text-align: left;
  color: #363636;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #d0d3d6;
  background-color: #6192b1;
  position: sticky;
  color: #fff;
}
.my-custom-scrollbar {
  /* position: relative; */
  max-height: 300px;
  /* max-width: 100%; */
  /* width: 100%; */
  overflow: auto;
}

.col-sm {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  padding-bottom: 0.5%;
  -ms-flex-positive: 1;
  -webkit-box-flex: 1;
  flex-grow: 1;
  max-width: 100%;
}
</style>